import {
  SET_ORDER_SUCCESS,
  SET_ORDER_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  saveOrder: [],
  error: {},
}

const setOrder = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ORDER_SUCCESS:
      return {
        ...state,
        saveOrder: action.payload,
      }

    case SET_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default setOrder
